// ANGULAR
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
// SERVICES
import { AlertService } from '@services/alert.service';
import { GlobalService } from '@services/global.service';
import { IPsService } from '@api-requests-services/ips.service';

export enum Views {
  Home = 'home',
  CreatingIpKey = 'creatingIpKey',
  DeletingIP = 'deletingIP',
  IpKeys = 'ipKeys',
  IpKeyDetail = 'ipKeysDetail',
  SearchByIP = 'searchByIP',
}

@Component({
  selector: 'app-ips',
  templateUrl: './ips.component.html',
  styleUrl: './ips.component.css',
  imports: [
    FormsModule,
    CommonModule
  ]
})
export class IpsComponent implements OnInit {
  ipKeys: string[];
  allIpKeys: string[];
  newIPKey: string;
  newIP: string;
  ipKeyToAdd: string;
  deleteAllIp: string = 'Todas';
  ipKeyOrIpToRemove: string;
  ipKeyOrIpToRemoveText: string;
  ipKeysOrIpToRemove: string[];
  ipKeyOrIP: string;
  ipKeySelected: string;
  ipKeyToSearch: string;
  expand: boolean = false;
  // Control de contenido html
  views = Views;
  currentView: string = Views.Home;

  constructor(
    private alertService: AlertService,
    public globalService: GlobalService,
    private ipsService: IPsService,
    private title: Title
  ) {
    this.title.setTitle('Oráculo - IPs');
  }

  ngOnInit(): void { }

  selectView(view: string, showAllIpKeys: boolean, ipKey?: string): void {
    if (ipKey) { this.ipKeySelected = ipKey; }
    this.currentView = view;

    switch (this.currentView) {
      case Views.Home:
        this.ipKeyOrIP = '';
        this.ipKeys = [];
        this.allIpKeys = [];
        this.ipKeysOrIpToRemove = [];
        this.newIPKey = '';
        this.newIP = '';
        this.ipKeyToAdd = '';
        this.ipKeyOrIpToRemove = '';
        this.ipKeyOrIP = '';
        this.ipKeySelected = '';
        this.ipKeyToSearch = '';
        break;
      case Views.IpKeys:
        this.getIpKeys(showAllIpKeys);
        break;
      case Views.IpKeyDetail:
        this.ipKeyToSearch = '';
        this.expand = false;
        this.newIPKey = this.ipKeySelected;
        this.reloadIPsList();
        break;
      case Views.CreatingIpKey:
        this.ipKeyOrIP = '';
        break;
      case Views.SearchByIP:
        this.ipKeyOrIP = '';
        break;
      case Views.DeletingIP:
        this.ipKeyOrIP = '';
        break;
    }
  }

  createIPKey(): void {
    this.ipsService.postCreateIpKey(this.ipKeyOrIP).subscribe(
      () => {
        this.getIpKeys(true);
        this.ipKeySelected = this.ipKeyOrIP;
        this.ipKeyOrIP = '';
        this.selectView(Views.IpKeyDetail, true);
        this.alertService.showAutoCloseMessage(`¡IP Key creada!`, ``, "success", 1200);
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error creating IP Key:', error);
        }
      }
    );
  }

  deleteIP(ipKeySelectedToDeleteIP: string, ipKeysOrIPs: string[]): void {
    let text: string = '';
    if (ipKeySelectedToDeleteIP === '*') {
      text = `¿Seguro que quieres eliminar la IP "${this.ipKeyOrIP}" de todas las IP Keys?`;
    } else if (ipKeysOrIPs[0] === this.deleteAllIp || ipKeysOrIPs[0] === '*') {
      text = `¿Seguro que quieres eliminar TODAS las IPs de la IP Key "${this.ipKeySelected}"?`;
      ipKeysOrIPs = this.ipKeysOrIpToRemove;
      ipKeysOrIPs = ipKeysOrIPs.slice(1);
    } else {
      text = `¿Seguro que quieres eliminar la IP "${ipKeysOrIPs[0]}" de la IP Key "${this.ipKeySelected}"?`;
    }

    this.alertService.showConfirmAlert(`Eliminar IP`, text).then((result) => {
      if (result.isConfirmed) {
        this.ipsService.deleteIP(ipKeySelectedToDeleteIP, ipKeysOrIPs).subscribe(
          () => {
            if (ipKeySelectedToDeleteIP === '*') {
              this.ipKeyOrIP = '';
              this.selectView(Views.Home, true);
            } else {
              this.ipKeyOrIpToRemoveText = '';
              this.reloadIPsList();
            }

            this.alertService.showAutoCloseMessage(`¡IP borrada!`, ``, "success", 1200);
          },
          error => {
            if (error.error === this.globalService.editModeDisabledMsg) {
              this.alertService.swalEditingNotEnabled();
            } else {
              this.alertService.swalError(error.error);
              console.error('Error deleting IP:', error);
            }
          }
        );
      }
    });
  }

  getIpKeys(showAllIpKeys: boolean): void {
    this.ipsService.getIpKeys().subscribe(
      (ipKeys) => {
        if (ipKeys) {
          // console.log('IP Keys: ', ipKeys);
          this.allIpKeys = ipKeys;
          this.ipKeyToAdd = this.getFilteredAllIpKeys()[0] ? this.getFilteredAllIpKeys()[0] : '';
          if (showAllIpKeys) {
            this.ipKeys = ipKeys;
          }
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting IP Keys:', error);
        }
      }
    );
  }

  getKeysFromIP(): void {
    this.ipsService.getKeysFromIP(this.ipKeyOrIP).subscribe(
      (ipKeys) => {
        if (ipKeys) {
          // console.log('IP Keys por IP: ', ipKeys);
          this.allIpKeys = ipKeys;
          this.ipKeys = ipKeys;
          this.ipKeyOrIP = '';
          this.selectView(Views.IpKeys, false);
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting IP Key from IP:', error);
        }
      }
    );
  }

  renameIPKey(): void {
    this.ipsService.postRenameIpKey(this.ipKeySelected, this.newIPKey).subscribe(
      () => {
        this.ipKeySelected = this.newIPKey;
        this.newIPKey = '';
        this.ipKeyToAdd = this.getFilteredAllIpKeys()[0] ? this.getFilteredAllIpKeys()[0] : '';
        this.alertService.showAutoCloseMessage(`¡Nombre de IP Key cambiado!`, ``, "success", 1200);
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error renaming IP Key:', error);
        }
      }
    );
  }

  addIPToKey(selectIpKey: boolean): void {
    let ipKeyOrIP: string = '';
    if (selectIpKey) {
      ipKeyOrIP = `#${this.ipKeyToAdd}`;
    } else {
      ipKeyOrIP = this.newIP;
    }

    this.ipsService.postAddIPToKey(this.ipKeySelected, ipKeyOrIP).subscribe(
      () => {
        this.newIP = '';
        this.reloadIPsList();
        this.alertService.showAutoCloseMessage(`¡IP añadida!`, ``, "success", 1200);
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error adding IP or IP Key:', error);
        }
      }
    );
  }

  getIPsFromKey(): void {
    this.ipsService.getIPsFromKey(this.ipKeySelected, this.expand).subscribe(
      (ips) => {
        if (ips) {
          // console.log('IPs por IP Key: ', ips);
          let html: string = '';
          for (let i = 0; i < ips.length; i++) { html += `<p style="margin: 0 0 5px 0;">${ips[i]}</p>`; }
          if (html === '') { html = 'No hay IPs'; }

          this.alertService.showHtmlMessage(`IPs`, html, "success", false);
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting IPs:', error);
        }
      }
    );
  }

  deleteIpKey(): void {
    this.alertService.showConfirmAlert(
      `Eliminar IP Key`,
      `¿Seguro que quieres eliminar la IP Key "${this.ipKeySelected}"?`
    ).then((result) => {
      if (result.isConfirmed) {
        this.ipsService.deleteIpKey(this.ipKeySelected).subscribe(
          () => {
            this.alertService.showAutoCloseMessage(`¡IP Key borrada!`, ``, "success", 1200);
            this.selectView(Views.IpKeys, true);
          },
          error => {
            if (error.error === this.globalService.editModeDisabledMsg) {
              this.alertService.swalEditingNotEnabled();
            } else {
              this.alertService.swalError(error.error);
              console.error('Error deleting IP Key:', error);
            }
          }
        );
      }
    });
  }

  reloadIPsList(): void {
    this.ipKeyToAdd = this.getFilteredAllIpKeys()[0] ? this.getFilteredAllIpKeys()[0] : '';

    this.ipsService.getIPsFromKey(this.ipKeySelected, false).subscribe(
      (ips) => {
        if (ips) {
          this.ipKeysOrIpToRemove = ips.length > 0 ? [this.deleteAllIp, ...ips] : [];
          this.ipKeyOrIpToRemove = this.ipKeysOrIpToRemove[0] ? this.ipKeysOrIpToRemove[0] : '';
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting IPs from IP Key:', error);
        }
      }
    );

  }

  onSearchChange(): void {
    this.ipKeys = this.allIpKeys.filter(ipKey => ipKey.toLowerCase().includes(this.ipKeyToSearch.toLowerCase()));

    if (this.ipKeyToSearch === undefined || this.ipKeyToSearch === '' || this.ipKeyToSearch === ' ') {
      this.ipKeys = this.allIpKeys;
    }
  }

  getFilteredAllIpKeys(): string[] {
    return this.allIpKeys.filter(ipKey => ipKey !== this.ipKeySelected);
  }
}